// todo: use autogenerated types instead of defining our own

import { Offer } from '../../ContentfulTypes';
import { InventoryStatus, ReserveStatus } from '../../types';
import { InventoryItem } from './types';

export const getMatchedOffersByColorAndSize = ({
  availableOffers,
  phoneColor,
  storageSize,
}: {
  availableOffers: Offer[];
  phoneColor?: string;
  storageSize?: string;
}) => {
  if (!phoneColor && !storageSize) {
    return availableOffers;
  }
  return availableOffers.filter(
    ({ memory, phoneColour: colour }) => (!storageSize || memory === storageSize)
      && (!phoneColor || phoneColor === colour?.displayName),
  );
};

export const getOffersWithInventory = ({
  matchedOffers,
  inventoryItems,
  phoneReserveStatus,
  reservableCarrierExists,
}: {
  matchedOffers: Offer[];
  inventoryItems: InventoryItem[];
  phoneReserveStatus: ReserveStatus;
  reservableCarrierExists: boolean;
}) => matchedOffers.reduce(
  (acc, offer) => {
    const matchingInventory = inventoryItems.find(
      ({ productSku }) => offer.sku === productSku,
    );

    // ironically if there is no matching inventory it becomes a part of offersWithInventory
    // I don't know why
    if (!matchingInventory) {
      return acc.concat(offer);
    }

    return phoneReserveStatus !== ReserveStatus.InventoryBased
        || matchingInventory.status !== InventoryStatus.NotFound
        || !reservableCarrierExists
      ? acc.concat({
        ...offer,
        status: matchingInventory.status,
        quantity: matchingInventory.quantity,
      })
      : acc;
  },
    [] as Array<Offer & { status?: InventoryStatus }>,
);
